// B-103 — an email Mantis proposes, previewed and approved by the operator before it goes: a note
// the office has to correct, the documents it still owes, a cash difference for the zone
// coordinator. The backend writes it from the client's template; this only previews it
// (`preview: true`), lets the operator add a comment or other addresses, and sends it.
//
// `enviar(preview, { to, comment })` is the call (one of the B-103 routes); "Para" empty is the
// office's own addresses (the Oficinas screen) unless `paraObligatorio`, which the coordinator's
// email is — Mantis does not keep the coordinators' addresses.
import { useEffect, useState } from "react";
import { Button, Spinner } from "@mantis-sas/ui";

import { correctionError } from "../../../utils/cierreCorrections";

const CAMPO = "mt-1 block w-full rounded-[6px] border px-2 py-1";

export function CorreoAOficina({
  titulo,
  enviar,
  onEnviado,
  onCancelar,
  textoEnviar = "Enviar a la oficina",
  ayudaPara = "Para (vacío: los correos de la oficina)",
  paraObligatorio = false,
}) {
  const [para, setPara] = useState("");
  const [comentario, setComentario] = useState("");
  const [vista, setVista] = useState(null);
  const [trabajando, setTrabajando] = useState(false);
  const [error, setError] = useState("");

  const llamar = async (preview) => {
    setTrabajando(true);
    setError("");
    const res = await enviar(preview, { to: para.trim() || undefined, comment: comentario.trim() || undefined }).catch(() => null);
    setTrabajando(false);
    if (!res?.success) {
      setError(correctionError(res) || "No se pudo preparar el correo.");
      return;
    }
    if (preview) setVista(res.data);
    else onEnviado(res.data);
  };

  // The email is shown as soon as the box opens: approving is the operator's whole job here.
  useEffect(() => {
    llamar(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listo = !trabajando && (!paraObligatorio || para.trim());

  return (
    <div className="mt-2 space-y-2 rounded-[8px] border bg-brinks-surface p-2.5 text-[12px]">
      <p className="font-medium text-brinks-foreground">{titulo}</p>
      {vista ? (
        <div className="space-y-1">
          <p className="font-medium">{vista.subject}</p>
          <iframe title="Vista previa del correo" sandbox="" srcDoc={vista.html} className="h-56 w-full rounded-[6px] border bg-white" />
        </div>
      ) : null}
      <label className="block">
        {ayudaPara}
        <input aria-label="Para" className={CAMPO} value={para} placeholder="correo@ejemplo.co" onChange={(e) => setPara(e.target.value)} />
      </label>
      <label className="block">
        Comentario (opcional)
        <textarea aria-label="Comentario" className={CAMPO} maxLength={2000} value={comentario} onChange={(e) => setComentario(e.target.value)} />
      </label>
      {error ? <p role="alert" className="text-brinks-danger">{error}</p> : null}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={trabajando} onClick={() => llamar(true)}>Vista previa</Button>
        <Button size="sm" disabled={!listo} onClick={() => llamar(false)}>
          {trabajando ? <Spinner size="sm" /> : textoEnviar}
        </Button>
        <Button size="sm" variant="outline" disabled={trabajando} onClick={onCancelar}>Cancelar</Button>
      </div>
    </div>
  );
}

export default CorreoAOficina;
